import React from 'react';
import SidebarLogo from '../../assets/SVGs/SidebarLogo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 mt-12 3xl:fixed 3xl:bottom-0 3xl:left-0 3xl:right-0 3xl:z-50 3xl:mt-0">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row items-center justify-between">  
          {/* Logo */}
          <div className="flex justify-start">
            <SidebarLogo width={100} height={22} color="#3D4966" />
          </div>
          
          {/* Links */}
          <div className="flex items-center space-x-4 sm:space-x-6">
            <a
              href="https://www.stitchfin.com/TermsofUse"
              className="text-gray-600 hover:text-[#153B4E] transition-colors duration-200 text-xs sm:text-sm font-medium"
            >
              Terms of Use
            </a>
            <a
              href="https://www.stitchfin.com/PrivacyPolicy"
              className="text-gray-600 hover:text-[#153B4E] transition-colors duration-200 text-xs sm:text-sm font-medium"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 